<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">设备信息</span>
      </div>
      <div style="width: 510px">
        <el-form
          ref="modelForm"
          :model="modelForm"
          :rules="modelRules"
          label-width="130px"
        >
          <el-form-item label="设备类型" prop="deviceType">
            <el-select
              v-model="modelForm.deviceType"
              style="width: 200px"
              placeholder="请选择设备类型"
            >
              <el-option
                v-for="item in allBrandArray"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <template v-if="modelForm.deviceType != '视频监控'">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="modelForm.deviceName" placeholder="请输入设备名称" />
            </el-form-item>
            <el-form-item label="设备编号" prop="deviceNum">
              <el-input v-model="modelForm.deviceNum" placeholder="请输入设备编号" />
            </el-form-item>
            <el-form-item label="网关编号" prop="gateWayNum">
              <el-input
                v-model="modelForm.gateWayNum"
                placeholder="请输入网关编号"
              />
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="视频URL" prop="monitorUrl">
              <el-input v-model="modelForm.monitorUrl" placeholder="请输入视频URL" />
            </el-form-item>
          </template>
          <el-form-item label="归属电站" prop="stationId">
            <el-select
              v-model="modelForm.stationId"
              style="width: 200px"
              filterable
              placeholder="请选择归属电站"
              @change="changeFn"
            >
              <el-option
                v-for="item in allStation"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :addrees="item.addrees"
                :op-name="item.opName"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="电站地址">
            <el-input v-model="modelForm.stationAddr" :disabled="true" />
          </el-form-item>
          <el-form-item label="运营商">
            <el-input v-model="modelForm.operator" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      // 所有的电桩品牌列表
      allBrandArray: [
        {
          name: '变压器',
          id: '0'
        },
        {
          name: '逆变器',
          id: '1'
        },
        {
          name: '储能系统',
          id: '2'
        },
        {
          name: '换电系统',
          id: '3'
        },
        {
          name: '照明系统',
          id: '4'
        },
        {
          name: '视频监控',
          id: '5'
        }
      ],
      // 归属电站
      allStation: [],
      // 所有的电桩类型
      allStationtype: [
        {
          name: '交流',
          id: 1
        },
        {
          name: '直流',
          id: 0
        }
      ],
      // 型号信息表单
      modelForm: {
        id: '',
        deviceType: '', // 设备类型
        deviceName: '', // 设备名称
        deviceNum: '', // 设备编号
        gateWayNum: '', // 网关编号
        monitorUrl: '', // 视频URL
        stationId: '', // 归属电站
        stationAddr: '', // 电站地址
        operator: '' // 运营商
      },
      modelRules: {
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceNum: [
          { required: true, message: '请输入设备编号', trigger: 'blur' }
        ],
        gateWayNum: [
          { required: true, message: '请选择网关编号', trigger: 'blur' }
        ],
        stationId: [
          { required: true, message: '请选择归属电站', trigger: 'change' }
        ],
        monitorUrl: [
          { required: true, message: '请输入视频URL', trigger: 'blur' }
        ]
      },
      workForm: {},
      imageUrl: '', // 上传成功的图片本地地址
      workRules: {
        equipPower: [
          { required: true, message: '请输入设备额定功率', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.modelForm.id = this.$route.query.id
      this.$store.dispatch('form/handle', {
        url: '/alarm/peripheral/detail?id=' + this.modelForm.id,
        method: 'get',
        callback: (resp) => {
          this.modelForm = JSON.parse(JSON.stringify(resp))
          // this.modelForm.zhuangType =
          //   this.modelForm.zhuangType == "交流" ? 1 : 2;
        }
      })
    }

    this.$store.dispatch('form/handle', {
      url: '/alarm/peripheral/selectStation',
      method: 'get',
      callback: (resp) => {
        resp.forEach(item => {
          this.allStation.push({ name: item.stationName, id: item.stationID, address: item.address, opName: item.opName })
        })
      }
    })
  },
  methods: {
    changeFn(e) {
      this.allStation.forEach(item => {
        if (item.id === e) {
          this.modelForm.stationAddr = item.address
          this.modelForm.operator = item.opName
        }
      })
    },
    // 点击提交的函数
    onSubmit() {
      let modelFormBool = false
      this.$refs['modelForm'].validate((valid) => {
        modelFormBool = valid
      })

      // 两个表单的验证通过
      if (modelFormBool) {
        // 进入数据提交函数
        this.submitData()
      }
    },
    submitData() {
      if (this.$route.query.id) {
        this.$store.dispatch('form/handle', {
          url: '/alarm/peripheral/update',
          data: this.modelForm,
          method: 'put',
          callback: (resp) => {
            this.$router.go(-1)
          }
        })
      }
      else {
        const obj = {}
        for (const key in this.modelForm) {
          if (key != 'id') {
            obj[key] = this.modelForm[key]
          }
        }
        this.$store.dispatch('form/handle', {
          url: '/alarm/peripheral/add',
          data: obj,
          method: 'put',
          callback: (resp) => {
            this.$router.go(-1)
          }
        })
      }
    },

    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.d-flex {
  display: flex;
}
.ml-20 {
  margin-left: 20px;
}
.pd-lr-10 {
  padding: 0 10px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-upload__tip {
  color: #409eff;
}
.el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 120px;
}
.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.3);
}
.custom {
  /deep/.el-input {
    width: 380px !important;
  }
}
.flexJCenter {
  display: flex;
  justify-content: center;
}
.mt-25 {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/nearModify.vue